import { type ShouldBlockFn, useBlocker } from "@tanstack/react-router";
import { useCallback } from "react";

export const UnsavedChangesGuard = ({
  enabled,
  message,
}: {
  enabled: boolean;
  message: string;
}) => {
  const shouldBlockFn = useCallback(
    (({ current, next }) =>
      enabled &&
      (current.routeId !== next.routeId || current.pathname !== next.pathname) &&
      !window.confirm(message)) satisfies ShouldBlockFn,
    [enabled, message],
  );

  useBlocker({ shouldBlockFn, enableBeforeUnload: enabled, disabled: !enabled });

  return null;
};
